import { render, staticRenderFns } from "./ContractorItemView.vue?vue&type=template&id=f92faa04&"
import script from "./ContractorItemView.vue?vue&type=script&lang=ts&"
export * from "./ContractorItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports